export default __webpack_public_path__ + "static/media/service-bg.ce55cfda.png";